import React, { Component } from "react";
import FourOhFour from "../containers/FourOhFour";
import { connect } from "react-redux";
import { utils } from "../common/utils";
//import { PageNavSectionsEnum } from "../common/enums";
import { withTranslation } from 'react-i18next';
import { getPage } from "../actions/pageActions";
import { withRouter } from "react-router";

class PageContent extends Component {

    loadPage() {
        const { pageId, location } = this.props;
        const { hash } = location;

        return this.props.getPage(pageId).then((response) => {
           // console.log(response);
            // if not a hash link, scroll to top
            if (hash === '') {
                window.scrollTo(0, 0);
            }
            // else scroll to id
            else {
                setTimeout(() => {
                    const id = hash.replace('#', '');
                    const element = document.getElementById(id);
                    if (element) {
                        utils.scrollTop(hash);
                       // element.scrollIntoView();
                    }
                }, 0);
            }
        }, (error) => {
            console.log(error)

        });
    }


    componentDidMount() {
        this.loadPage();
    }

    componentDidUpdate(prevProps, prevState) {
        const { pageId } = this.props;

        if (prevProps.pageId !== pageId) { // payment error 
            this.loadPage();
        }
    }

    render() {
        const { page } = this.props;
        if (page.notFound === true)
            return <FourOhFour />;

        utils.scrollTop();
        const decodedContent = utils.htmlDecode(page.content);
        return (
            <div dangerouslySetInnerHTML={{ __html: decodedContent }} />
        );
    }
}


function mapStateToProps({page }, ownProps) {
    return { page, ...ownProps };
}


export default withTranslation()(withRouter(connect(mapStateToProps, { getPage })(PageContent)));

